import { render, staticRenderFns } from "./WolfObservations.vue?vue&type=template&id=242784c6&scoped=true&"
import script from "./WolfObservations.vue?vue&type=script&lang=js&"
export * from "./WolfObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242784c6",
  null
  
)

export default component.exports